import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Pause"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-pause',
    templateUrl: './icon-pause.component.html',
    styleUrls: ['./icon-pause.component.scss'],
    standalone: false
})
export class IconPauseComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
